import { render } from "./NotificarEmbargoPersonaComponent.vue?vue&type=template&id=7b15d9c1"
import script from "./NotificarEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./NotificarEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__